import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { addMonths, format as formatDate, subMonths } from 'date-fns';
import { ChevronLeft, ChevronRight } from '../../icons';
import { IconButton } from '../IconButton';
import { Typography } from '../Typography';
import styles from './DatePicker.module.scss';
import { GetDateCalendarTID } from './DatePicker.utils';
export const defaultHeaderFormat = 'MMMM yyyy';
export function CalendarHeader(props) {
    const { currentMonth, onMonthChange, testIdRoot, labelId, headerFormat = defaultHeaderFormat } = props;
    const { DateCalendarTestIds } = useMemo(()=>GetDateCalendarTID(testIdRoot), [
        testIdRoot
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.header,
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- month nav is an inherent fixed-semantic action of the calendar; not consumer-named
                bi: {
                    name: 'prev_month'
                },
                testId: DateCalendarTestIds.PrevMonth(testIdRoot) || undefined,
                onClick: ()=>onMonthChange(subMonths(currentMonth, 1), 'right'),
                "aria-label": "Previous month",
                children: /*#__PURE__*/ _jsx(ChevronLeft, {})
            }),
            /*#__PURE__*/ _jsx(Typography, {
                id: labelId,
                className: styles.headerLabel,
                testId: DateCalendarTestIds.MonthLabel(testIdRoot) || undefined,
                children: formatDate(currentMonth, headerFormat)
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- month nav is an inherent fixed-semantic action of the calendar; not consumer-named
                bi: {
                    name: 'next_month'
                },
                testId: DateCalendarTestIds.NextMonth(testIdRoot) || undefined,
                onClick: ()=>onMonthChange(addMonths(currentMonth, 1), 'left'),
                "aria-label": "Next month",
                children: /*#__PURE__*/ _jsx(ChevronRight, {})
            })
        ]
    });
}
